import React, {forwardRef, useImperativeHandle, useRef} from 'react'

import {Input} from './index.js'
import {InputChangeEvent, InputRef} from './Input.js'
import {FieldProps, FieldRef, InvalidProps} from './types.js'

export interface FloatInputProps extends FieldProps, InvalidProps {
    value?: string | number
    onChange?: (event: InputChangeEvent) => void
    append?: React.ReactNode
}

export type FloatInputRef = FieldRef

const FloatInput = forwardRef<FloatInputRef, FloatInputProps>(function FloatInput(props, ref) {
    const {value, onChange, label, info, append, disabled, readOnly, isInvalid, style} = props

    const inputRef = useRef<InputRef | null>(null)

    useImperativeHandle(ref, () => ({
        focus: () => inputRef.current?.focus(),
        blur: () => inputRef.current?.blur(),
        setInvalid: (isInvalid = true) => inputRef.current?.setInvalid(isInvalid)
    }), [])

    const handleChange = (event: InputChangeEvent) => {
        // Numeric keypads type '.', use the ',' decimal separator like CurrencyInput
        event.target.value = event.target.value?.replace('.', ',')

        if (/^$|^[-]{0,1}[0-9]{0,5}$|^[-]{0,1}[0-9]{0,5}[,][0-9]{0,2}$/.test(event.target.value)) {
            onChange?.(event)
        }
    }

    return (
        <Input
            label={label}
            info={info}
            value={value}
            onChange={handleChange}
            append={append}
            disabled={disabled}
            readOnly={readOnly}
            isInvalid={isInvalid}
            style={style}
            ref={inputRef}
        />
    )
})

export default FloatInput
